export type EnquiryType = "supplier" | "franchise" | "b2b" | "general";

// Display labels only — a real routing rule would live in a backend that
// doesn't exist yet (see ZP-56/57/58's "routes to X team" AC). Response
// times are illustrative SLA copy, same register as Partnerships.tsx's
// pre-existing "within two business days" line.
export const ENQUIRY_TEAM: Record<EnquiryType, string> = {
  supplier: "Procurement",
  franchise: "Business Development",
  b2b: "Corporate Sales",
  general: "Customer Support",
};

export const ENQUIRY_RESPONSE_TIME: Record<EnquiryType, string> = {
  supplier: "3–5 business days",
  franchise: "3–5 business days",
  b2b: "1–2 business days",
  general: "1 business day",
};
